import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import React, { useState } from "react";

const HeaderMenu = ({ context }) => {
  const [localSearch, setLocalSearch] = useState("");

  const handleSearch = () => {
    context.setSearch(localSearch);
    context.setPage(1);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <span className="p-input-icon-left d-flex gap-2">
      <div className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          value={localSearch}
          onChange={(e) => setLocalSearch(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Busca..."
        />
      </div>
      <Button
        icon="pi pi-search"
        label="Buscar"
        onClick={handleSearch}
        style={{
          backgroundColor: "#FAC109",
          outline: 0,
          border: "none",
          color: "#fff"
        }}
        className="p-button"
      />
    </span>
  );
};

export default HeaderMenu;
